module.exports = __webpack_public_path__ + "16c562edc2d186d418f583c61fe4a355.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Technology/top-left.jpg
// module id = 873
// module chunks = 1